import { render, staticRenderFns } from "./boxNow.vue?vue&type=template&id=7c142423"
import script from "./boxNow.vue?vue&type=script&lang=js"
export * from "./boxNow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports